if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const sliders = document.querySelectorAll('.ct_history:not(.admin_preview');

    if (sliders) {
        sliders.forEach((sliderContainer) => {
            const slider = sliderContainer.querySelector('.slider');

            if (!slider) {
                return;
            }

            const navContainer = sliderContainer.querySelector('.slickNav');
            const eraNav = sliderContainer.querySelector('.js-history-era-nav');

            jQuery(slider).slick({
                arrows: true,
                infinite: true,
                appendArrows: navContainer ?? slider,
                prevArrow: '<button class="btn slick-prev"><i class="fal fa-long-arrow-left"></i></button>',
                nextArrow: '<button class="btn slick-next"><i class="fal fa-long-arrow-right"></i></button>',
            });

            if (eraNav) {
                jQuery(slider).on('afterChange', (e, slick, currentSlide) => {
                    const currentSlideElement = slick.$slides[currentSlide];
                    const historyEvent = currentSlideElement.querySelector('.history-event');
                    const slideTerm = historyEvent.dataset.eraTerm;
                    const currentActive = eraNav.querySelector('.active');

                    if (currentActive.dataset.eraTerm === slideTerm) {
                        return;
                    }

                    currentActive.classList.remove('active');

                    const newActive = eraNav.querySelector(`[data-era-term="${slideTerm}"]`);
                    if (newActive) {
                        newActive.classList.add('active');
                    }
                });

                eraNav.addEventListener('click', (e) => {
                    const button = e.target.closest('button');

                    if (!button) {
                        return;
                    }

                    const eraTerm = button.dataset.eraTerm;
                    const slide = slider.querySelector(`[data-era-term="${eraTerm}"]`);
                    if (!slide) {
                        return;
                    }
                    const slideIndex = slide.dataset.slideIndex;
                    jQuery(slider).slick('slickGoTo', slideIndex);
                });
            }
        });
    }
}
